import colors from './colors';
import screen from './screen';
import fonts from './fonts/index';
import zindex from './z-index';
import fontsV2 from './fonts-v2';
export default { colors, fonts, screen, zindex, fontsV2 };
